import React, { useState } from 'react';
import styles from './SocialNetworks.module.scss';
import Facebook from '../../Icons/Facebook';
import Linkedin from '../../Icons/Linkedin';
import Instagram from '../../Icons/Instagram';
import Youtube from '../../Icons/Youtube';

export default function SocialNetworks() {
  const [hoveredIcon, setHoveredIcon] = useState(null);

  const handleMouseOver = (iconName) => {
    setHoveredIcon(iconName);
  };

  const handleMouseOut = () => {
    setHoveredIcon(null);
  };

  return (
    <div className={styles.socialNetworks}>
      <a
        href="https://www.facebook.com/omodajaecoobelux/"
        target="_blank"
        onMouseOver={() => handleMouseOver('facebook')}
        onMouseOut={handleMouseOut}
        rel="noreferrer"
      >
        <Facebook isHover={hoveredIcon === 'facebook'} />
      </a>
      <a
        href="https://www.linkedin.com/company/jaecoobenelux/"
        target="_blank"
        onMouseOver={() => handleMouseOver('linkedin')}
        onMouseOut={handleMouseOut}
        rel="noreferrer"
      >
        <Linkedin isHover={hoveredIcon === 'linkedin'} />
      </a>
      <a
        href="https://www.instagram.com/omodajaecoo.belux/"
        target="_blank"
        onMouseOver={() => handleMouseOver('instagram')}
        onMouseOut={handleMouseOut}
        rel="noreferrer"
      >
        <Instagram isHover={hoveredIcon === 'instagram'} />
      </a>
      <a
        href="https://www.youtube.com/@OMODAJAECOO-BELUX"
        target="_blank"
        onMouseOver={() => handleMouseOver('youtube')}
        onMouseOut={handleMouseOut}
        rel="noreferrer"
        className={styles.youtube}
      >
        <Youtube isHover={hoveredIcon === 'youtube'} />
      </a>
    </div>
  );
}
